/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ParticipationRecordRowFragment = {
  __typename?: 'ParticipationRecord';
  id: string;
  status: Types.ParticipationRecordStatus;
  statusDisplayName?: string | null;
  investorName: string;
  investorType?: string | null;
  aum?: number | null;
  allocationQuantity?: number | null;
  allocationNotional?: number | null;
  allocationNotionalUsd?: number | null;
  indicationQuantity?: number | null;
  indicationNotional?: number | null;
  indicationNotionalUsd?: number | null;
  isRoadshowParticipant?: boolean | null;
  linkedCmgEntityKey?: string | null;
  createdAt: string;
  modifiedAt: string;
  firm?: { __typename?: 'Firm'; name: string } | null;
  lastModifiedBy?: {
    __typename?: 'LastModifiedBy';
    name?: string | null;
    email?: string | null;
  } | null;
};

export type ParticipationSetInfoFragment = {
  __typename?: 'ParticipationSet';
  id: string;
  lastUploadedAt: string;
  uploadedBy: string;
};

export type OfferingProfile_GetParticipationRecordsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.ParticipationRecordFilterInput>;
  setFilter?: Types.InputMaybe<Types.ParticipationSetFilterInput>;
}>;

export type OfferingProfile_GetParticipationRecordsQuery = {
  __typename?: 'Query';
  participationRecords?: {
    __typename?: 'ParticipationRecordCollectionSegment';
    items?: Array<{
      __typename?: 'ParticipationRecord';
      id: string;
      status: Types.ParticipationRecordStatus;
      statusDisplayName?: string | null;
      investorName: string;
      investorType?: string | null;
      aum?: number | null;
      allocationQuantity?: number | null;
      allocationNotional?: number | null;
      allocationNotionalUsd?: number | null;
      indicationQuantity?: number | null;
      indicationNotional?: number | null;
      indicationNotionalUsd?: number | null;
      isRoadshowParticipant?: boolean | null;
      linkedCmgEntityKey?: string | null;
      createdAt: string;
      modifiedAt: string;
      firm?: { __typename?: 'Firm'; name: string } | null;
      lastModifiedBy?: {
        __typename?: 'LastModifiedBy';
        name?: string | null;
        email?: string | null;
      } | null;
    }> | null;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean };
  } | null;
  participationSets?: {
    __typename?: 'ParticipationSetCollectionSegment';
    items?: Array<{
      __typename?: 'ParticipationSet';
      id: string;
      lastUploadedAt: string;
      uploadedBy: string;
    }> | null;
  } | null;
};

export const ParticipationRecordRowFragmentDoc = gql`
  fragment ParticipationRecordRow on ParticipationRecord {
    id
    status
    statusDisplayName
    investorName
    investorType
    aum
    allocationQuantity
    allocationNotional
    allocationNotionalUsd
    indicationQuantity
    indicationNotional
    indicationNotionalUsd
    isRoadshowParticipant
    linkedCmgEntityKey
    createdAt
    modifiedAt
    firm {
      name
    }
    lastModifiedBy {
      name
      email
    }
  }
`;
export const ParticipationSetInfoFragmentDoc = gql`
  fragment ParticipationSetInfo on ParticipationSet {
    id
    lastUploadedAt
    uploadedBy
  }
`;
export const OfferingProfile_GetParticipationRecordsDocument = gql`
  query OfferingProfile_GetParticipationRecords(
    $skip: Int
    $take: Int
    $where: ParticipationRecordFilterInput
    $setFilter: ParticipationSetFilterInput
  ) {
    participationRecords(skip: $skip, take: $take, where: $where) {
      items {
        ...ParticipationRecordRow
      }
      pageInfo {
        hasNextPage
      }
    }
    participationSets(where: $setFilter) {
      items {
        ...ParticipationSetInfo
      }
    }
  }
  ${ParticipationRecordRowFragmentDoc}
  ${ParticipationSetInfoFragmentDoc}
`;

/**
 * __useOfferingProfile_GetParticipationRecordsQuery__
 *
 * To run a query within a React component, call `useOfferingProfile_GetParticipationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingProfile_GetParticipationRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingProfile_GetParticipationRecordsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      setFilter: // value for 'setFilter'
 *   },
 * });
 */
export function useOfferingProfile_GetParticipationRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OfferingProfile_GetParticipationRecordsQuery,
    OfferingProfile_GetParticipationRecordsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingProfile_GetParticipationRecordsQuery,
    OfferingProfile_GetParticipationRecordsQueryVariables
  >(OfferingProfile_GetParticipationRecordsDocument, options);
}
export function useOfferingProfile_GetParticipationRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingProfile_GetParticipationRecordsQuery,
    OfferingProfile_GetParticipationRecordsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingProfile_GetParticipationRecordsQuery,
    OfferingProfile_GetParticipationRecordsQueryVariables
  >(OfferingProfile_GetParticipationRecordsDocument, options);
}
export function useOfferingProfile_GetParticipationRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingProfile_GetParticipationRecordsQuery,
        OfferingProfile_GetParticipationRecordsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingProfile_GetParticipationRecordsQuery,
    OfferingProfile_GetParticipationRecordsQueryVariables
  >(OfferingProfile_GetParticipationRecordsDocument, options);
}
export type OfferingProfile_GetParticipationRecordsQueryHookResult = ReturnType<
  typeof useOfferingProfile_GetParticipationRecordsQuery
>;
export type OfferingProfile_GetParticipationRecordsLazyQueryHookResult = ReturnType<
  typeof useOfferingProfile_GetParticipationRecordsLazyQuery
>;
export type OfferingProfile_GetParticipationRecordsSuspenseQueryHookResult = ReturnType<
  typeof useOfferingProfile_GetParticipationRecordsSuspenseQuery
>;
export type OfferingProfile_GetParticipationRecordsQueryResult = Apollo.QueryResult<
  OfferingProfile_GetParticipationRecordsQuery,
  OfferingProfile_GetParticipationRecordsQueryVariables
>;
